import { render, staticRenderFns } from "./PartnershipM.vue?vue&type=template&id=342da2a2"
import script from "./PartnershipM.vue?vue&type=script&lang=js"
export * from "./PartnershipM.vue?vue&type=script&lang=js"
import style0 from "./PartnershipM.vue?vue&type=style&index=0&id=342da2a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports